import React from "react";
import Switch from "@ls/react-switch";
import { useDispatch, useSelector } from "react-redux";
import SelectionState from "state/selections/SelectionState";
import { selectDisplayBenchmarkValue } from "state/selections/selector";
import { setDisplayBenchmarks } from "state/selections/actions";

const DisplayBenchSwitch = (props) => {
  const value = useSelector(
    selectDisplayBenchmarkValue(SelectionState.UNCOMMITTED)
  );
  const dispatch = useDispatch();
  const onChange = React.useCallback(
    (value) => {
      dispatch(setDisplayBenchmarks(value));
    },
    [dispatch]
  );
  return (
    <Switch
      onChange={onChange}
      value={value}
      label="Display Benchmarks"
      raised
    />
  );
};

export default DisplayBenchSwitch;
